<script lang="ts" setup>
import { useLtiStore } from '@@/pinia/lti_store'
import GlobalAlertDialog from '@@/vuecomponents/GlobalAlertDialog.vue'
import LtiAuthOrgLoginScreen from '@@/vuecomponents/LtiAuthOrgLoginScreen.vue'
import LtiAuthOrgVerificationScreen from '@@/vuecomponents/LtiAuthOrgVerificationScreen.vue'
import LtiDeeplinkMenuScreen from '@@/vuecomponents/LtiDeeplinkMenuScreen.vue'
import LtiErrorScreen from '@@/vuecomponents/LtiErrorScreen.vue'
import LtiSuccessScreen from '@@/vuecomponents/LtiSuccessScreen.vue'
import { onMounted, watch } from 'vue'

const ltiStore = useLtiStore()

watch(
  () => ltiStore.isAwaitingServerResponse,
  (value) => {
    if (ltiStore.xDeeplinkMenuScreen) return
    const html = document.getElementsByTagName('html')[0]

    // Animate the background color while waiting for the response
    // Note: Only do this when submitting the login form
    if (value) {
      html.classList.add('dot-grid-loading')
    } else {
      html.classList.remove('dot-grid-loading')
    }
  },
)

watch(
  () => ltiStore.xDeeplinkMenuScreen,
  (value) => {
    if (value) {
      const html = document.getElementsByTagName('html')[0]

      // Remove all background classes when entering the deeplink menu screen.
      html.classList.remove('dot-grid')
      html.classList.remove('dot-grid-loading')
    }
  },
)
onMounted(() => {
  if (ltiStore.xDeeplinkMenuScreen) return
  const html = document.getElementsByTagName('html')[0]
  html.classList.add('dot-grid')
})
</script>

<template>
  <div class="w-full h-full">
    <LtiAuthOrgVerificationScreen v-if="ltiStore.xOrgVerificationScreen" />
    <LtiAuthOrgLoginScreen v-else-if="ltiStore.xLoginScreen" />
    <LtiDeeplinkMenuScreen v-else-if="ltiStore.xDeeplinkMenuScreen" />
    <LtiErrorScreen v-else-if="ltiStore.xErrorScreen" />
    <LtiSuccessScreen v-else-if="ltiStore.xSuccessScreen" />
    <GlobalAlertDialog />
  </div>
</template>

<style lang="postcss">
@import '@@/styles/4/kit';
@import '@@/styles/4/dot_grid';

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html {
  @apply h-screen;
  @apply bg-light-ui-100;
  @apply dark:bg-dark-ui-100;
  font-size: 16px;
}
</style>
